export default "__VITE_ASSET__GXr114rb__"